(() => {
  const root = document.documentElement;
  let queued = false;
  function sync() {
    queued = false;
    const panel = document.querySelector('#snize-instant-search-results');
    const mobile = panel?.classList.contains('snize-ac-results-mobile') && !!panel.getClientRects().length;
    root.classList.toggle('ph-searchanise-open', !!mobile);
    if (!panel) return;
    root.classList.remove('ph-search-open');
    const input = panel.querySelector('#snize-mobile-search-input');
    if (input) {
      if (input.getAttribute('aria-label') !== 'Search products') input.setAttribute('aria-label', 'Search products');
      input.placeholder = 'Search for a meaningful gift';
    }
    const close = panel.querySelector('.snize-close-button-arrow');
    if (close && close.textContent !== 'Cancel') {
      close.textContent = 'Cancel';
    }
    if (close && close.getAttribute('aria-label') !== 'Cancel search') close.setAttribute('aria-label', 'Cancel search');
    const content = panel.querySelector('.snize-ac-results-content');
    if (mobile && content && !content.querySelector('.ph-searchanise-discover')) {
      const source = document.querySelector('.t4s-is-header-categories-menu .ph-search-discover');
      if (source) {
        const discover = source.cloneNode(true);
        discover.classList.add('ph-searchanise-discover');
        content.append(discover);
      }
    }
    const query = (input?.value ?? document.querySelector('.t4s-search-header__input')?.value ?? '').trim();
    panel.classList.toggle('ph-searchanise-empty', !query);
  }
  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(sync); }
  }
  new MutationObserver(records => {
    if (records.some(r => r.type === 'childList' || r.attributeName === 'aria-label' || r.target.id === 'snize-instant-search-results')) schedule();
  }).observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['aria-label','style']});
  document.addEventListener('input', e => {
    if (e.target.matches('#snize-mobile-search-input,.t4s-search-header__input')) schedule();
  });
  document.addEventListener('click', e => {
    if (e.target.closest('.snize-clear-button,.snize-close-button')) schedule();
  });
  sync();
})();
